// React import
import { useState } from 'react';

// FontAwesomeIcon imports
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsis } from '@fortawesome/pro-regular-svg-icons';

// Mui imports
import Menu from '@mui/material/Menu';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';

// Local imports
import ZPopper from './ZPopper.js';

function ContextMenu(props) {
    const { options, anchor, icon, color } = props;

    const [anchorEl, setAnchorEl] = useState(null);
    const [subMenu, setSubMenu] = useState(null);
    const open = Boolean(anchorEl);
    const subMenuOpen = Boolean(subMenu);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSubMenuClick = (params) => {
        setSubMenu(params);
    };

    const handleSubMenuClose = () => {
        setSubMenu(null);
    };

    return (
        <>
            <IconButton onClick={handleClick} color={color}>
                <FontAwesomeIcon style={{ fontSize: '18px' }} icon={icon || faEllipsis} />
            </IconButton>
            <Menu 
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: anchor === 'right' ? 'right' : 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: anchor === 'right' ? 'left' : 'right',
                }}
                sx={{
                    zIndex: 99999999999
                }}
            >
                {options.map(op => ((op.key + '').startsWith('divider') ? (
                    <Divider key={op.key} />
                ): op.submenu ? (
                    <MenuItem
                        key={op.key}
                        disabled={op.disabled}
                        onClick={(event) => handleSubMenuClick({ target: event.currentTarget, menu: op.submenu })}
                        sx={op.sx || {}}
                    >
                        {op.icon}&nbsp;&nbsp;{op.label}
                    </MenuItem>
                ) : (
                    <MenuItem
                        key={op.key}
                        disabled={op.disabled}
                        onClick={() => {
                            handleClose();
                            op.onClick();
                        }}
                        sx={op.sx || {}}
                    >
                        {op.icon}&nbsp;&nbsp;{op.label}
                    </MenuItem>
                )))}
            </Menu>
            {subMenu && (
                <Menu
                    anchorEl={subMenu.target}
                    open={subMenuOpen}
                    onClose={handleSubMenuClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: anchor === 'right' ? 'right' : 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: anchor === 'right' ? 'left' : 'right',
                    }}
                >
                    {subMenu.menu.map(sub => (
                        <MenuItem
                            key={sub.key}
                            disabled={sub.disabled}
                            onClick={() => {
                                handleSubMenuClose();
                                handleClose();
                                sub.onClick();
                            }}
                            sx={sub.sx || {}}
                        >
                            {sub.icon}&nbsp;&nbsp;{sub.label}
                        </MenuItem>
                    ))}
                </Menu>
            )}
        </>
    );
}

export default ContextMenu;
